import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

import {
  load,
  fetchTableData,
  searchUrlChange,
  clearAllData,
  getErrorMessage,
  getNode,
} from "./store";

import { withLayout } from "../../components/layout/Layout";
import { Input } from "../../components/input/Input";
import { Form, FormSubmitButton } from "../../components/form";
import { DomainLookupTable } from "./components";
import { useMount } from "@sportal/cdk/hooks";
import { useIntlTranslate } from "../../hooks";
import { AriaPageTitle } from "../../components/ariaPageTitle";
import { Desktop } from "../../hocs/Responsive";
import { withPageName } from "../../components/layout/horizontalMenu/PageName";

import "./DomainLookupPage.scss";

export const DomainLookupContent = () => {
  const translate = useIntlTranslate();
  const dispatch = useDispatch();
  const node = useSelector(getNode);
  const error = useSelector(getErrorMessage);

  const handleSubmit = () => dispatch(fetchTableData(node));

  const handleNodeChange = (e) => {
    dispatch(searchUrlChange(e.target.value));
  };
  const handleNodeClear = () => {
    dispatch(searchUrlChange(""));
    dispatch(clearAllData());
  };

  useMount(() => {
    dispatch(load());

    return () => dispatch(clearAllData());
  });

  return (
    <section className={"domain-lookup"}>
      <AriaPageTitle pageKey="page_title_domain_lookup_page" />
      <Desktop>
        <h1 className="domain-lookup__header">
          <FormattedMessage id={"domain_lookup"} />
        </h1>
      </Desktop>

      <Form
        onSubmit={handleSubmit}
        name={"domainLookupForm"}
        description={<FormattedMessage id={"domain_search_tip"} />}
      >
        <div className={"domain-lookup__search-form"}>
          <Input
            className="domain-lookup__input"
            data-testid="domain-lookup-input"
            id="domain-lookup"
            value={node}
            onChange={handleNodeChange}
            onClear={handleNodeClear}
            label={<FormattedMessage id={"domain_name"} />}
            error={error}
            autoComplete="url"
            placeholder={translate("url_placeholder")}
          />

          <FormSubmitButton
            label={<FormattedMessage id="search" />}
            disabled={_.isEmpty(node)}
          />
        </div>
        <DomainLookupTable className={"domain-lookup__table"} />
      </Form>
    </section>
  );
};

export const DomainLookupPage = _.flowRight(
  withLayout(),
  withPageName()
)(DomainLookupContent);
